const Manifesto = () => {
    return (
        <section
            data-testid="manifesto-section"
            className="border-b border-white/10 relative overflow-hidden"
        >
            <div className="absolute inset-0 bg-blueprint opacity-30 pointer-events-none" />
            <div className="relative px-6 md:px-12 lg:px-16 py-20 md:py-32 grid grid-cols-12 gap-10">
                <div className="col-span-12 lg:col-span-3">
                    <p className="text-xs md:text-sm font-mono tracking-[0.3em] uppercase text-white/50">
                        / 004 — Manifiesto
                    </p>
                </div>
                <div className="col-span-12 lg:col-span-9">
                    <h2 className="font-display uppercase leading-[0.9] tracking-tighter text-4xl md:text-6xl lg:text-7xl">
                        <span className="text-[#1A9EC9]">Terah</span>: Alta{" "}
                        <span className="text-stroke">ingeniería</span> en
                        infraestructura crítica.
                    </h2>
                    <p className="mt-10 font-mono text-base md:text-lg text-white/70 leading-relaxed max-w-3xl">
                        En Terah tratamos cada sistema como lo que es:
                        infraestructura crítica. Cámaras, UPS, switches,
                        sensores de humo... cada uno es una decisión que debe
                        sostenerse bajo presión real, no solo en condiciones
                        ideales. Por eso ofrecemos un solo responsable para
                        diseño, instalación y operación, de principio a fin.
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14">
                        {[
                            {
                                title: "Una sola contraparte",
                                desc: "Olvida coordinar múltiples proveedores. Nosotros respondemos por todo el sistema.",
                                testid: "manifesto-1",
                            },
                            {
                                title: "Operación verificable",
                                desc: "Dashboards, reportes y bitácoras auditables. Lo que no se mide, no se opera.",
                                testid: "manifesto-2",
                            },
                            {
                                title: "Ingeniería sin atajos",
                                desc: "Certificaciones NFPA, CompTia, CCNA, HCIA, HCSA.",
                                testid: "manifesto-3",
                            },
                        ].map((m) => (
                            <div
                                key={m.testid}
                                data-testid={m.testid}
                                className="border border-white/10 p-6 hover:border-[#1A9EC9] transition-colors"
                            >
                                <div className="font-display uppercase text-lg tracking-tight mb-2">
                                    {m.title}
                                </div>
                                <p className="font-mono text-xs leading-relaxed text-white/60">
                                    {m.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Manifesto;
